/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateBrandDto
 */
export interface CreateUpdateBrandDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateBrandDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateBrandDto
     */
    budgetId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateBrandDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateBrandDto interface.
 */
export function instanceOfCreateUpdateBrandDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "budgetId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateBrandDtoFromJSON(json: any): CreateUpdateBrandDto {
    return CreateUpdateBrandDtoFromJSONTyped(json, false);
}

export function CreateUpdateBrandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateBrandDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'budgetId': json['budgetId'],
        'active': json['active'],
    };
}

export function CreateUpdateBrandDtoToJSON(value?: CreateUpdateBrandDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'budgetId': value.budgetId,
        'active': value.active,
    };
}

